<template>
  <div v-if="surveyId">
    <app-qaheader></app-qaheader>
    <app-popup v-if="whatPop"></app-popup>
    <div class="card">
      <div class="card-middle">
        <div class="card-middle-inside">
          <div v-html="checkRisk(surveyId, avarage[surveyId])[0]">
          </div>
          <div class="avarage-bar">
            <div class="avarage-bar-user" :style="{marginLeft: (Number(avarage[surveyId].toFixed(2))-1)/2*100+'%'}">
              Din virksomhed
            </div>
            <div class="avarage-bar-inside">

            </div>
            <div class="avarage-bar-all" :style="{marginLeft: (Number(allAvarage)-1)/2*100+'%'}" v-if="survey[surveyId].showallcompanys">
              Andre virksomheder
            </div>
          </div>
          <small v-if="survey[surveyId].showallcompanys">Gennemsnittet er beregnet ud fra alle tidligere gennemførte Sikkerhedstjek</small>
        </div>
      </div>
      <div class="card-result-wrapper">
        <div v-for="(a, aCount) in answers[surveyId]" :key="a.id" class="card-result">
          <div v-show="aCount == 1" class="overlay">
            <app-SoftPermissionEmail v-if="firm.userid"></app-SoftPermissionEmail>
            <app-PermissionEmail v-else></app-PermissionEmail>
          </div>

          <div class="card-result-inside">
            <h5>{{ survey[surveyId].cat[aCount].name }}</h5>
            <div class="avarage-cat-wrapper">
              <div class="avarage-cat">
                <div class="avarage-cat-inside" :class="getAvarageCat(aCount)[1]">

                </div>
              </div>
              <div class="avarage-cat-text">
                Samlet risiko for {{ survey[surveyId].cat[aCount].name.toLowerCase() }}: <b>{{ getAvarageCat(aCount)[2]}}</b>
              </div>
            </div>

            <div v-html="getAvarageCat(aCount)[0]">
            </div>
          </div>
          <div class="more" v-show="toggle[aCount].el">
            <div class="rsp-table">
              <div class="rsp-table-head">
                <div class="rsp-table-row">
                  <div class="rsp-table-column" data-label="Spørgsmål">
                    <div class="border">
                      Spørgsmål
                    </div>
                  </div>
                  <div class="rsp-table-column" data-label="Svar">
                    <div class="border">
                      Svar
                    </div>
                  </div>
                  <div class="rsp-table-column" data-label="Risiko">
                    <div class="border">
                      Risiko
                    </div>
                  </div>
                  <div class="rsp-table-column rsp-table-column-hightlighted" data-label="Anbefaling">
                    <div class="border">
                      Anbefaling
                    </div>
                  </div>
                  <div class="rsp-table-column" data-label="Links">
                    <div class="border">
                      Links
                    </div>
                  </div>
                </div>
              </div>
              <div class="rsp-table-body" v-for="(an, anCount) in answers[surveyId][aCount].q" :key="an.id">
                <div class="rsp-table-row" v-for="(svar, svarCount) in answers[surveyId][aCount].q[anCount].a" :key="svar.id">
                  <div class="rsp-table-column" data-label="Spørgsmål">
                    <div class="border" v-if="svarCount == 0">
                      {{ survey[surveyId].cat[aCount].questions[an.q].title }}
                    </div>
                  </div>
                  <div class="rsp-table-column" data-label="Svar">
                    <div class="border">
                      {{ survey[surveyId].cat[aCount].questions[an.q].answers[svar].title }}
                    </div>
                  </div>
                  <div class="rsp-table-column" data-label="Risiko">
                    <div class="border">
                      <div>
                        <div class="avarage-cat-inside" :class="checkRisk(surveyId, survey[surveyId].cat[aCount].questions[an.q].answers[svar].score)[1]">

                        </div>
                        <div class="avarage-cat-text">
                          {{ checkRisk(surveyId, survey[surveyId].cat[aCount].questions[an.q].answers[svar].score)[2]}} risiko
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rsp-table-column rsp-table-column-hightlighted" data-label="Anbefaling">
                    <div class="border">
                      {{ survey[surveyId].cat[aCount].questions[an.q].answers[svar].recommendation}}
                    </div>
                  </div>
                  <div class="rsp-table-column" data-label="Links">
                    <div class="border">
                      <div class="links" v-html="survey[surveyId].cat[aCount].questions[an.q].answers[svar].links">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-result-inside">
            <p>
              <a href="#" @click.prevent.default="toggle[aCount].el = !toggle[aCount].el" class="readmore-plus" v-if="!toggle[aCount].el">
                Se {{ getAvarageCat(aCount)[3] }} <span v-if="getAvarageCat(aCount)[3] < 2">anbefaling</span><span v-if="getAvarageCat(aCount)[3] > 1">anbefalinger</span> for {{ survey[$route.params.survey].cat[aCount].name.toLowerCase() }}
              </a>
              <a href="#" @click.prevent.default="toggle[aCount].el = !toggle[aCount].el" class="readmore-minus" v-if="toggle[aCount].el">
                Luk
              </a>
            </p>
          </div>


        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-bottom">
        <div class="card-bottom-inside">
          <h4>Falck Sikkerhedstjek</h4>
        </div>
      </div>
    </div>
    <app-callus></app-callus>
    <app-cfooter></app-cfooter>
  </div>
</template>

<script>
import Callus from './modular/call-us.vue';
import qaheader from './modular/question-header.vue';
import Cfooter from '../components/modular/cfooter.vue';
import PermissionEmail from './permissionEmail.vue';
import SoftPermissionEmail from './softPermissionEmail.vue';
import Popup from '../components/modular/popup-permission.vue';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
import {db} from '../database/firebase';
import Marked from 'marked';
export default {
  name: 'Contact',
  components: {
    appQaheader: qaheader,
    appPermissionEmail: PermissionEmail,
    appSoftPermissionEmail: SoftPermissionEmail,
    appCallus: Callus,
    appPopup: Popup,
    appCfooter: Cfooter
  },
  firebase() {
    return {
      score: {
        source: db.ref('score/'+this.$route.params.survey),
        readyCallback: function () {
          if(!this.surveyIsActive || this.surveyIsActive){
            let s = this.$route.params.survey
            var sum = 0;
            var oLength = Number(this.score.length + 1)

            for( var el in this.score ) {
              if( this.score.hasOwnProperty( el ) ) {
                sum += parseFloat( this.score[el].score );
              }
            }
            sum += this.avarage[s];
            let newValue = sum/oLength
            this.allAvarage = newValue.toFixed(2);

            db.ref('answers').child(s).child(this.firm.firmId).set({
              //firma: this.firm,
              score:  this.avarage[s].toFixed(2),
              answer: this.answers[s],
              completed:false
            })
            db.ref('score').child(s).child(this.firm.firmId).set({
              score: this.avarage[s]
            })
            this.category = this.survey[this.$route.params.survey].cattoshow - 1
            this.surveyId = this.$route.params.survey
            this.setSurveyActive(false);
            for( var el in this.answers[this.surveyId] ) {
              this.toggle.push({el:false});
            }
            if(this.firm.noform){
              this.$router.push({ path: '/rapport/'+this.$route.params.survey+'/'+this.firm.firmId })
            }
          }
        }
      }
    }
  },
  data () {
    return {
      allAvarage:'',
      toggle:[],
      category:'',
      surveyId:''
    }
  },
  computed: {
    ...mapGetters([
      'survey',
      'answers',
      'answersCount',
      'avarage',
      'surveyIsActive',
      'whatPop',
      'firm'
    ])
  },
  mounted() {
    if(!this.surveyIsActive){
      this.$router.push({ path: '/survey/'+ this.$route.params.survey })
    }


  },
  methods: {
    ...mapActions([
      'setPrev',
      'setSurveyActive'
    ]),
    percentage(num, per){
      return ( Number(num)/100 ) * per;
    },
    compiledMarkdown(text) {
      return Marked(text, { sanitize: true })
    },
    checkRisk(s, average){
      if(average > 2.5){
        return [this.compiledMarkdown(this.survey[s].recommendationlow),'low','Lav' ]
      }else if(average > 1.5){
        return [this.compiledMarkdown(this.survey[s].recommendationmedium),'medium', 'Mellem']
      }else{
        return [this.compiledMarkdown(this.survey[s].recommendationhigh),'high','Høj']
      }
    },
    getAvarageCat(cat){
      let s = this.$route.params.survey
      let sum = 0;
      let times = 0;
      for (var cAverage in this.answers[s][cat].q) {
        for (var cScore in this.answers[s][cat].q[cAverage].score) {
          sum += parseFloat(this.answers[this.$route.params.survey][cat].q[cAverage].score[cScore]);
          times++
        }
      }

      let average = sum/times;


      if(average > 2.5){
        return [this.compiledMarkdown(this.survey[s].cat[cat].recommendationlow), "low", "Lav", times]
      }else if(average > 1.5){
        return [this.compiledMarkdown(this.survey[s].cat[cat].recommendationmedium), "medium", "Mellem", times]
      }else{
        return [this.compiledMarkdown(this.survey[s].cat[cat].recommendationhigh), "high", "Høj", times]
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.overlay{
  background-color: rgba(255,255,255,0.8);
  position: absolute;
  z-index: 99;
  width:100%;
  height:100%;
}
.card-bottom{
  min-height: 0;
}
.card-bottom-inside{
  width: 588px;
  padding: 30px 20px 10px;
  margin: 0 auto;
}
.links >>> a {
  display: block;
}
  .btn-light{
    display: block;
    max-width: 306px;
    margin-bottom: 20px;
  }
  .card-2col {
    padding: 30px 0px;
    width: 588px;
    margin: 0 auto;
  }
  .anbefaling-box{
    position: relative;
    z-index: 2;
    width:200px;
    height:200px;
    display: flex;
    justify-content: center;
    align-items: center;
    left:100px;
    top:-40px;
  }
  .anbefaling-box-inside{
    position: relative;

    z-index: 5;
    text-align: center;
  }
  .red-box{
    z-index: 1;
    content:'';
    background-color: red;
    width:200px;
    height:200px;
    position: absolute;
    transform: rotate(45deg);
    border-radius: 20px;
  }
  h2{
    font-size: 100px;
    color: #FFFFFF;
    letter-spacing: -1.39px;

    line-height: 80px;
  }

</style>



// WEBPACK FOOTER //
// src/components/result.vue